export default __webpack_public_path__ + "static/media/twitter_bg_white_color_gray.cb9fdb12.svg";